(ns teamoesterreich.admin-mode.event.detail.member-selector.filter-age
  (:require
    [clojure.string]
    [reagent.core :as r]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent-material-ui.icons.save :refer [save]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    ))



(def DEFAULT {:type :age :name "Minimum Alter" :short ">0"})


(defn edit-filter-popup [opt !edit-item-popup !filter-item]
  [mui/modal
   {:aria-labelledby  "simple-modal-title"
    :aria-describedby "simple-modal-description"
    :style            {:display        "flex"
                       :marginRight    "auto"
                       :marginLeft     "auto"
                       :alignItems     "center"
                       :justifyContent "center"}
    :open             (not (nil? @!edit-item-popup))
    }
   [:div
    {
     :class "modal"
     :style {:width 600}}
    [:h2 "Kriterium bearbeiten"]
    (case (:type @!edit-item-popup)
      :age [:div
            [:h4 "Alter"]
            [mui/text-field {:value "12-99"}]]
      :gender [:div
               [:h4 "Geschlecht"]
               [mui/text-field {:value "12-99"}]]
      [:span "??"]
      )
    [mui/button
     {:variant   "contained"
      :startIcon (r/as-element [keyboard-arrow-left])
      :style     {:marginRight 50}
      :onClick   #(reset! !edit-item-popup nil)
      }
     "Abbrechen"]]]
  )



